import { useNavigate, useParams } from "react-router-dom";
import {
  PushContentWrapper,
  MainHeaderWrapper,
  MainWrapper,
  PushContent,
} from "./style/pushDetail";
import { useEffect, useState } from "react";

import { useRecoilValue } from "recoil";
import { getPushDetail, getPinCount } from "../../../../api/push";
import {
  PageWrapper,
  PageHeader,
  PageContentHeader,
} from "../../../../styles/page";
import { pubState } from "../../../../recoil/pub.atom";
import Preview from "../pushPreview";
import { PushWarning } from "../pushSend/style/pushSend";
import { PubOwnerRole, PubOwnerDomain } from "../../../../api/cafe";

const PushMessage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const pub = useRecoilValue(pubState);

  const [pushTitle, setPushTitle] = useState("");
  const [pushText, setPushText] = useState("");
  const [check, setCheck] = useState("");
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.MARKETING)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  const getData = async () => {
    if (!id) {
      console.log("id :", id);
      return;
    }

    const data = await getPushDetail(+id);
    setPushTitle(data.title);
    setPushText(data.description);
    setCheck(data.target);
  };

  const getCount = async () => {
    if (!pub) {
      return;
    }

    const data = await getPinCount(+pub.id);
    setCount(data);
  };

  useEffect(() => {
    getData();
    getCount();
  }, []);

  return (
    <>
      <PageWrapper>
        <PageHeader>PUSH 메시지</PageHeader>
        <MainWrapper>
          <PageContentHeader>
            <div className="title">메시지 내역</div>
            <MainHeaderWrapper>
              <div>
                <span className="countTitle">발송 가능 횟수</span>
                <span>{count}회</span>
              </div>
            </MainHeaderWrapper>
          </PageContentHeader>
          <PushContentWrapper>
            <PushContent>
              <div className="pushTitleWrapper">
                <div>알림 제목</div>
                <div className="pushTitle">{pushTitle}</div>
              </div>
              <div className="pushTitleWrapper">
                <div>알림 텍스트</div>
                <div className="pushText">{pushText}</div>
              </div>
              <div className="pushTitleWrapper">
                <div>예약</div>
                <div>
                  <input
                    type="radio"
                    name="res"
                    checked={check === "ALL" ? true : false}
                  />{" "}
                  <span>지금보내기</span>
                  <input
                    type="radio"
                    name="res"
                    checked={check === "PINPOINT" ? true : false}
                  />{" "}
                  <span>예약 보내기</span>
                </div>
              </div>
            </PushContent>

            <Preview pushTitle={pushTitle} pushText={pushText} />
          </PushContentWrapper>
        </MainWrapper>
        <PushWarning>
          ※러너러너를 통해 푸시메시지를 전송 시, 현행법에 위배되는 내용이
          있을경우, 민형사상의 처벌대상이 될 수 있으며, 이에따른 내용은
          러너러너에서 도움을 드릴 수 없습니다.※
        </PushWarning>
      </PageWrapper>
    </>
  );
};

export default PushMessage;
